import { makeAutoObservable } from "mobx"
import { GenderType } from "./index.d"

const Params = new URL(window.location.href).searchParams
class FormStore {
  calc_step: number = 0

  // Step 1
  calc_parentDOB: string = "" // #pdob
  calc_parentAge: number = 0 // #page
  calc_parentGender: GenderType = "Male" // #pgender
  calc_childDOB: string = "" // #cdob
  calc_childAge: number = 0 // #cage
  calc_childMonths: number = 0
  calc_childDays: number = 0
  calc_childGender: GenderType = "Male" // #cgender
  calc_childName: string = "" // #cname

  // Step 2
  calc_profession: string = "" // #profession
  calc_professionOther: string = "" // #professionOther
  calc_duration: number = 0 // #duration
  calc_invest: number = 1000000 // #invest
  calc_policyTerm: number = 0 //cppt

  // Step 3
  calc_mode: string = "Monthly" // #mode


  //Step 4 
  calc_savingValue: number = 0


  // Step 5
  calc_mobile: number | string = "" // #MobileNo
  calc_income: number | string = "" // #AnnualIncome
  calc_email: string = "" // #EmailId
  calc_NDNC: boolean = true // #traiFlag
  calc_occupation: number|string =""

  // Quick Guide
  quick_slide: number = 0

  constructor() {
    makeAutoObservable(this)
  }

  setCalcStep = (data: number) => (this.calc_step = data)

  // Step 1
  setCalcParentDOB = (data: string) => (this.calc_parentDOB = data)
  setCalcParentAge = (data: number) => (this.calc_parentAge = data)
  setCalcParentGender = (data: GenderType) => (this.calc_parentGender = data)
  setCalcChildDOB = (data: string) => (this.calc_childDOB = data)
  setCalcChildAge = (data: number) => (this.calc_childAge = data)
  setCalcChildMonths = (data: number) => (this.calc_childMonths = data)
  setCalcChildDays = (data: number) => (this.calc_childDays = data)
  setCalcChildGender = (data: GenderType) => (this.calc_childGender = data)
  setCalcChildName = (data: string) => (this.calc_childName = data)
  
  // Step 2
  setCalcProfession = (data: string) => (this.calc_profession = data)
  setCalcProfessionOther = (data: string) => (this.calc_professionOther = data)
  setCalcDuration = (data: number) => (this.calc_duration = data)
  setCalcInvest = (data: number) => (this.calc_invest = data)
  setPolicyTerm = (data: number) => (this.calc_policyTerm = data)

  // Step 3
  setCalcMode = (data: string) => (this.calc_mode = data)


  // Step 4
  setCalcSavingValue =(data: number) => (this.calc_savingValue = data) //cpremium

  // Step 5
  setCalcMobile = (data: number | string) => (this.calc_mobile = data)
  setCalcAnnualIncome = (data: number | string) => (this.calc_income = data)
  setCalcOccupation = (data: number | string) => (this.calc_occupation = data)
  setCalcEmail = (data: string) => (this.calc_email = data)
  setCalcNDNC = (data: boolean) => (this.calc_NDNC = data)

  // QUick Guide
  setQuickGuideSlide = (data: number )=> (this.quick_slide = data)
}

export default new FormStore()
